import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { FaEye } from "react-icons/fa";
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const Ven_Ladger_Payment_List = () => {
    const token = localStorage.getItem('token');
    const navigate = useNavigate();
    const [data, setVendorDataDetails] = useState([]);
    const ven_ladger_id = localStorage.getItem('ven_ladger_id');
    const ven_costomer_id = localStorage.getItem('ven_costomer_id');

    useEffect(() => {
        fetchVendorDetails();
    }, [token]);

    const fetchVendorDetails = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}Vendor-ledger-payment-list/${ven_ladger_id}/customer_id/${ven_costomer_id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': token,
                },
            });
            const otherData = response.data.data || [];
            setVendorDataDetails(otherData);
        } catch (error) {
            console.error('Error fetching vendors:', error);
        }
    };

    return (
        <>
            <div className="App">
                <div className="card">
                    <div className="card-header">
                        <div className="d-flex">

                            <div><Link to='/vendor-ladgor' className='btn-added'>Back</Link></div>
                        </div>
                    </div>

                    <div className="card-body">
                        <table className='table table-striped hover border'>
                            <thead className='thead-dark'>
                                <tr>
                                    <th>Sr.no</th>
                                    <th>Date</th>
                                    <th>Vendor Name</th>
                                    <th>Customer Name</th>
                                    <th>Amount</th>
                                    <th>Account</th>
                                    <th>Mode</th>
                                   
                                </tr>
                            </thead>
                            <tbody className='trcolorchange'>
                                {data && data.map((vendor, index) => (
                                    <tr key={vendor.vendor_id}>
                                        <td>{index + 1}</td>
                                        <td>{vendor.created_at}</td>
                                        <td>{vendor.vendor_name}</td>
                                        <td>{vendor.customer_name}</td>
                                        <td>{vendor.amount}</td>
                                        <td>{vendor.Account_name}</td>
                                        <td>{vendor.mode}</td>
                                        
                                    </tr>
                                ))}
                            </tbody>
                        </table>


                    </div>
                </div>
            </div>
        </>
    );
};

export default Ven_Ladger_Payment_List;
